import { GeoLocation, Search } from '@/services/models';

export const searchLocationMixins = {
	methods: {
		async searchExecute(location, options = {}) {
			if (location) {
				// Global search - user press enter or enters via another page
				if(options.isGlobalSearch){
					const search = new Search({
						search: location,
						type: 'global', 
						...options }
					);
					search.execute(this.$router);
				}else

				// Search with selected GeoLocation
				if (location instanceof GeoLocation) {
					const search = new Search({ ...location, ...options });
					search.execute(this.$router);
				}

				// Else, try to locate address from typed string before searching
				else {
					const { lat, lng } = Object(Object(Object(await this.$store.dispatch('search/getLocationFromAddress', location)).geometry).location);
					if ((lat, lng)) {
						const search = new Search({
							lat,
							lng,
							search: location,
							type: 'geo',
							...options
						});
						search.execute(this.$router);
					} else {
						this.$eventBus.$emit('snackbar', {
							text: 'Finner ikke stedet du prøver å søke etter. Vennligst prøv igjen...',
							type: 'warning'
						});
					}
				}

				this.$google.sendEventButtonClick('search-button', 'frontpage', '');
			}
		}
	}
};
